import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function OAuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    
    if (code && state) {
      // Backend will handle the OAuth callback
      fetch(`${BACKEND_URL}/api/social/oauth/callback?code=${code}&state=${state}`, {
        credentials: 'include'
      })
      .then(response => {
        if (response.ok) {
          navigate('/dashboard?connected=true');
        } else {
          navigate('/dashboard?error=connection_failed');
        }
      })
      .catch((error) => {
        console.error('OAuth callback error:', error);
        navigate('/dashboard?error=connection_failed');
      });
    } else {
      navigate('/dashboard?error=invalid_callback');
    }
  }, [searchParams, navigate, BACKEND_URL]);
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-blue-50 to-white">
      <div className="text-center">
        <div className="text-2xl font-semibold text-gray-900 mb-4">
          🔗 Connecting your account...
        </div>
        <div className="text-gray-600">
          Please wait while we complete the connection.
        </div>
      </div>
    </div>
  );
}
